export const OUTBOUND = 'OUTBOUND';
export const INBOUND = 'INBOUND';
export const RETURN_JOURNEY = 'RETURN';
export const MAX_DAYS_SEARCH = 19;
export const MIN_DAYS_SEARCH = 7;
